module.exports = __webpack_public_path__ + "assets/photos/memories/frame-7-mobile--98e15cb6e7106b01f62e8458b5d285a6.jpg";